import { RootActionTypes } from '../../../stores/types';
import ActionType from '../constants/ActionType';

export default function hideReturnPolicyWorksheet(): RootActionTypes {
  return {
    type: ActionType.HideReturnPolicyWorksheet,
  };
}
